var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vertical-form-table', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'vertical-form-table', {
    mode: _vm.mode,
    items: _vm.items
  }, false), [_c('template', {
    slot: "비밀번호 확인"
  }, [_c('v-password-confirm-field', {
    attrs: {
      "password": _vm.form.password,
      "outlined": ""
    }
  })], 1), _c('template', {
    slot: "연락처"
  }, [_c('user-contact-certification', {
    attrs: {
      "outlined": "",
      "dense": "",
      "btnAttrs": {
        color: 'primary',
        width: 100,
        height: 50,
        className: 'mt-n8'
      }
    },
    on: {
      "change": _vm.emit
    },
    model: {
      value: _vm.form.phone,
      callback: function ($$v) {
        _vm.$set(_vm.form, "phone", $$v);
      },
      expression: "form.phone"
    }
  })], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }